import { Input } from "@/components/ui/input";
import { SearchableSelect } from "@/components/ui/searchable-select";
import type { EmailToTaskFormApi } from "@/hooks/useEmailToTaskForm";
import { SectionBlock } from "../SectionBlock";
import { Field, ToggleRow } from "./fields";

const REVIEW_OPTIONS = [
	{ value: "always", label: "Always review before creating tasks" },
	{ value: "auto", label: "Auto-approve confident drafts (coming later)", disabled: true },
];

export function ReviewNotifyCard({ form, setField, disabled }: EmailToTaskFormApi) {
	return (
		<SectionBlock
			title="Review and notifications"
			description="Who can review is set in Role Permissions (Review email inbox)."
		>
			<div className="grid gap-4 sm:grid-cols-2">
				<Field label="Review mode">
					<SearchableSelect
						value={form.review_mode}
						onValueChange={() => setField("review_mode", "always")}
						options={REVIEW_OPTIONS}
						disabled={disabled}
						ariaLabel="Review mode"
					/>
				</Field>
				<Field label="Max processing attempts" htmlFor="ett-attempts" hint="After this many failures the email is marked failed.">
					<Input
						id="ett-attempts"
						type="number"
						min={1}
						max={10}
						value={form.max_attempts}
						onChange={(e) => setField("max_attempts", Number(e.target.value))}
						disabled={disabled}
					/>
				</Field>
			</div>
			<div className="mt-3 divide-y divide-border">
				<ToggleRow
					label="Email the sender when drafts are ready"
					description="Also exposes forged emails: the real sender gets a notice for an email they never sent."
					checked={form.notify_sender_on_ready}
					onChange={(v) => setField("notify_sender_on_ready", v)}
					disabled={disabled}
				/>
				<ToggleRow
					label="Email the sender when tasks are created"
					checked={form.notify_sender_on_approved}
					onChange={(v) => setField("notify_sender_on_approved", v)}
					disabled={disabled}
				/>
				<ToggleRow
					label="Notify reviewers in TaskHub"
					checked={form.notify_reviewers_in_app}
					onChange={(v) => setField("notify_reviewers_in_app", v)}
					disabled={disabled}
				/>
			</div>
		</SectionBlock>
	);
}
